import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Affix, Button, Card, Dropdown, Menu, Popconfirm, Space } from "antd";
import ListTable from "common/ListTable";
import { DELETE_NEW_TNA_TASK_DATA, GET_ALL_NEW_TNA_TASK_DATA } from "apiServices/API_ENDPOINTS";
import { deleteData, getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import CustomFilter from "components/Common/CustomFilter";
import Header from "components/Common/Header";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  TNA_TASK_CREATE_PERMISSION,
  TNA_TASK_DELETE_PERMISSION,
  TNA_TASK_EDIT_PERMISSION,
  TNA_TASK_VIEW_PERMISSION,
} from "routes/permissions";
import { hasPermission } from "utils/functions";

const NewTask = (props) => {
  const { width } = props;

  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [newTaskList, setNewTaskList] = useState();
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rangeData, setRangeData] = useState();

  const getAllNewTaskList = useCallback(
    async (filterValues) => {
      setLoading(true);
      const bodyData = {
        per_page: rangeData || 10,
        page: currentPage,
        ...filterValues,
      };

      const response = await getData(GET_ALL_NEW_TNA_TASK_DATA, false, bodyData);

      if (response && response?.data?.code === 200) {
        const masterData = response?.data;
        const result = masterData?.data?.data
          ?.slice()
          ?.sort((a, b) => (b?.id || 0) - (a?.id || 0))
          ?.map((task) => {
            return {
              id: task?.id,
              title: task?.title,
              relation_with: task?.relation_with,
              process: task?.process?.title,
            };
          });

        setNewTaskList(result);
        setTotalData(masterData?.data?.total);
        setRangeData(masterData?.data?.per_page);
      } else {
        HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
      }

      setLoading(false);
    },
    [rangeData, currentPage],
  );

  useEffect(() => {
    getAllNewTaskList();
  }, [currentPage, getAllNewTaskList]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Relation With",
      dataIndex: "relation_with",
      key: "relation-with",
    },
    {
      title: "Process",
      dataIndex: "process",
      key: "process",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <div className="cursore-pointer">
          <Dropdown overlay={menu(record)}>
            <MoreOutlined style={{ fontSize: "20px" }} />
          </Dropdown>
        </div>
      ),
    },
  ];

  const deleteSelectedItem = async (id) => {
    const query = `${DELETE_NEW_TNA_TASK_DATA}/${id}`;
    const response = await deleteData(query);

    if (response) {
      HandleNotification("success", "bottomRight", "Task deleted successfully!", null);
      getAllNewTaskList();
    } else {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }
  };

  const menu = (data) => (
    <Menu
      items={[
        {
          label: (
            <Link to={`/tanda/view-new-task/${data.id}`}>
              <EyeOutlined /> View
            </Link>
          ),
          key: "0",
          disabled: !hasPermission([TNA_TASK_VIEW_PERMISSION]),
        },
        {
          label: (
            <Link to={`/tanda/update-new-task/${data.id}`}>
              <EditOutlined /> Edit
            </Link>
          ),
          key: "2",
          disabled: !hasPermission([TNA_TASK_EDIT_PERMISSION]),
        },
        {
          label: (
            <Popconfirm
              title="Are you sure you want to delete?"
              onConfirm={() => {
                deleteSelectedItem(data?.id);
              }}
            >
              <span
                style={{
                  color: "red",
                }}
              >
                <DeleteOutlined /> Delete
              </span>
            </Popconfirm>
          ),
          key: "1",
          disabled: !hasPermission([TNA_TASK_DELETE_PERMISSION]),
        },
      ]}
    />
  );

  const paginate = (page) => {
    setCurrentPage(page);
  };

  const extra = (
    <Space>
      <Button
        type={showFilter ? "danger" : "primary"}
        size="small"
        onClick={() => setShowFilter((prev) => !prev)}
        style={{ float: "right" }}
      >
        {`${showFilter ? "Close" : "Open"} Filter Option`}
      </Button>
      <Button key="3" size="small" type="primary" disabled={!hasPermission([TNA_TASK_CREATE_PERMISSION])}>
        <Link to="/tanda/add-new-task">
          {hasPermission([TNA_TASK_CREATE_PERMISSION]) ? "Add New" : "No Permission"}
        </Link>
      </Button>
    </Space>
  );

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        tableData={newTaskList}
        fetchTableData={getAllNewTaskList}
        filterName="tna_task"
      />
    ),
    [showFilter],
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header title="Task" subTitle="" actions={extra} />
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          {memoizedCustomFilter}
          <ListTable
            loading={loading}
            dataSource={newTaskList}
            columns={columns}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => paginate(page),
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </Fragment>
  );
};

export default NewTask;
